import { render, staticRenderFns } from "./subconta.vue?vue&type=template&id=79125b60&"
import script from "./subconta.vue?vue&type=script&lang=ts&"
export * from "./subconta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports